var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44427 14.8672L12.4422 18.8651L16.44 14.8672",
    stroke: "currentColor",
    strokeWidth: 1.49921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4421 9.86914V18.8644",
    stroke: "currentColor",
    strokeWidth: 1.49921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3176 15.9569C22.1865 15.3459 22.8381 14.4739 23.1779 13.4674C23.5176 12.4609 23.5278 11.3724 23.207 10.3597C22.8861 9.34707 22.251 8.463 21.3936 7.8358C20.5363 7.20861 19.5014 6.87092 18.4391 6.87175H17.1798C16.8792 5.70024 16.3167 4.6122 15.5348 3.68952C14.7528 2.76684 13.7717 2.03357 12.6654 1.54493C11.559 1.05628 10.3562 0.824981 9.14756 0.868447C7.93888 0.911913 6.75581 1.22901 5.68742 1.79587C4.61902 2.36272 3.69315 3.16456 2.97949 4.14103C2.26583 5.11749 1.78298 6.24313 1.56731 7.4332C1.35163 8.62328 1.40874 9.84677 1.73434 11.0116C2.05993 12.1764 2.64553 13.2522 3.44705 14.1579",
    stroke: "currentColor",
    strokeWidth: 1.49921,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBlack);
export default __webpack_public_path__ + "static/media/cloudBlack.10b2ece7.svg";
export { ForwardRef as ReactComponent };